import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TouristComponent } from './tourist.component';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    NgbDropdownModule,
    FormsModule,
    NgxUsefulSwiperModule
  ],
  declarations: [TouristComponent],
  exports: [TouristComponent]
})
export class TouristModule { }
